import { Col, Modal, Row } from 'antd';
import styled from 'styled-components';

const DrawerItems = styled(Row)`
  padding: 20px;
  padding-top: 5px;
  .contentData {
  
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #efeded;

      border-radius: 6px;
      min-height: 2px;
      max-height: 5px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #555;
    }
  }
`;

const ModalDetailsEvent = styled(Modal)`
  .ant-modal-body {
    padding-top: 10px;
  }

  .contentInfo {
    margin-top: 30px;
  }

  .btnEdit {
    min-width: 98px !important;
  }

  .video {
    display: flex;
    background: #595bdd;
    height: 32px;
    justify-content: center;
    vertical-align: center;
    margin: auto;
    color: white;
    :hover {
    }
    .icon {
      color: white;
      width: 25px;
      height: 25px;
      .feather {
        width: 50px;
        size: 90px;
      }
    }
  }
`;

const ColTitleEvent = styled(Col)`
  /* margin-bottom: 30px; */
  div {
    width: 100%;
    margin-bottom: 0px;

    div {
      align-items: center;
      align-content: center;
    }
  }
  span {
    font-size: 16px;
  }
  .divider {
    margin-top: 10px !important;
  }
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-top: 6px;
  }
  .textService {
    margin-top: 4px;
  }

  .btonIcon {
    border: none;
    box-shadow: none;
    padding: 0;
    background: none;
  }
`;

const TextInfo = styled.span`
  font-weight: bold;
  font-size: 14px;
  margin-right: 3px;
`;

const ColEvents = styled(Col)`
  display: flex;
  flex-direction: column;
  padding: 5px;
  overflow: hidden;
  margin: auto;
  width: 100%;

  .event-attr {
    display: flex;
    align-items: center;
  }

  .video {
    display: flex;
    background: #595bdd;
    height: 32px;
    justify-content: center;
    vertical-align: center;
    margin: auto;
    :hover {
    }
    .icon {
      color: white;
      width: 25px;
      height: 25px;
      .feather {
        width: 50px;
        size: 90px;
      }
    }
  }

  .event-icon {
    margin-right: 5px;
    display: flex;
    align-items: center;
  }

  .event-attr-icon {
    width: 15px;
    margin-right: 10px;
  }
  .event-attr-text {
    flex: 1;
    color: #333;
    font-size: 16px;
    text-align: left;
  }
  .event-attr-description {
    text-align: justify;
    white-space: pre-line;
  }
  .text {
    font-size: 14px;
  }
  .description {
    margin-top: 10px;
  }
`;

export { DrawerItems, ColEvents, ModalDetailsEvent, ColTitleEvent, TextInfo };
